module.exports = __webpack_public_path__ + "media/images/v2/illustration_2-27edc39fe8bdc479aeb44895e4d96acd.svg";